/* eslint-disable no-console */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Input, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import {EfdbName} from '../../constants/efdbNameConstants';
import InformativeText from '../../constants/InformativeText';
import NumberInput from '../../shared/NumberInput';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {eachWordCap} from '../../utils/FormUtils/FirstCap';
import RegEx from '../../utils/FormUtils/RegEx';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import SelectWithOtherOption from '../CustomInputs/Select/SelectWithOtherOption';
import MomentDatePicker from '../DatePicker/MomentDatePicker';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {
  downPropertyKey,
  downPropertyLabel
} from './Constants/IP/dSPropertyKeyLabel';
import {unitTypes} from './interface/unitChange';
import changeUnit from './Utils/changeUnit';
import {filterSelectOptions} from './Utils/commonFunctions';

const DownPropertyForm: React.FC<{currentStep?: number}> = ({currentStep}) => {
  const FormInstance = useFormInstance();
  const {setFields, getFieldValue} = FormInstance;
  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();

  const vehicleType = useJSONStore.getState().vehicleType;
  const vehicleFuelUsed = useJSONStore.getState().vehicleFuelUsed;

  const [fuelState, setFuelState] = useState(() => {
    return (
      vehicleFuelUsed?.find(
        (item) => item?.value === getFieldValue(downPropertyKey.FUEL_USED)
      )?.state ?? unitTypes.VOLUME_LIQUID
    );
  });

  useEffect(() => {
    setFuelState(
      vehicleFuelUsed?.find((item: any) => {
        return item.value === getFieldValue(downPropertyKey.FUEL_USED);
      })
    );
  }, [getFieldValue(downPropertyKey.FUEL_USED)]);

  const assetInfo = InformativeText?.AM;

  return (
    <>
      {currentStep === 0 && (
        <>
          {/* <Col className="gutter-row"> */}
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={yearFilter}
                suffixIcon={<YearCalender />}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.ASSET_NAME}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.ASSET_NAME)
                },
                {
                  max: 100,
                  message: `${downPropertyLabel.ASSET_NAME} should be less than 100 characters`
                },
                {
                  min: 3,
                  message: `${downPropertyLabel.ASSET_NAME} should be more than 2 characters`
                },
                {
                  pattern: RegEx.fullName,
                  message: CommonErrors.noSpecialChar
                },
                {
                  whitespace: true,
                  message: CommonErrors.mandatory(downPropertyLabel.ASSET_NAME)
                }
              ]}
              label={downPropertyLabel.ASSET_NAME}
              labelCol={{span: 24}}
              initialValue={''}
              tooltip={{
                icon: <InfoCircleOutlined />,
                title: assetInfo?.assetName,
                style: {cursor: 'default'}
              }}
            >
              <Input
                className="input"
                placeholder={`Enter ${downPropertyLabel.ASSET_NAME}`}
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = eachWordCap(target.value);
                }}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.FIRST_NAME}
              label={downPropertyLabel.FIRST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.FIRST_NAME)
                },
                {
                  max: 100,
                  message: `${downPropertyLabel.FIRST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${downPropertyLabel.FIRST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${downPropertyLabel.FIRST_NAME}`}
              />
            </Form.Item>
          </Col> */}
          {/* <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.LAST_NAME}
              label={downPropertyLabel.LAST_NAME}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.LAST_NAME)
                },
                {
                  max: 100,
                  message: `${downPropertyLabel.LAST_NAME} Should not be more than 100 Characters`
                },
                {
                  min: 2,
                  message: `${downPropertyLabel.LAST_NAME} Should be more than 1 Characters`
                },
                {
                  pattern: RegEx.names,
                  message:
                    'No special characters , Empty spaces or Numbers are Allowed'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input
                onInput={(e) => {
                  const target = e.target as HTMLInputElement;
                  target.value = FirstCap(target.value);
                }}
                placeholder={`Enter ${downPropertyLabel.LAST_NAME}`}
              />
            </Form.Item>
          </Col> */}
          {/* <Col className="gutter-row" span={colSpan}> */}
          {/* <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.ASSET_MOBILE}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(
                    downPropertyLabel.ASSET_MOBILE
                  )
                },
                {
                  // eslint-disable-next-line @typescript-eslint/promise-function-async
                  validator(_, value) {
                    if (RegEx.mobile.test(value)) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        new Error(
                          CommonErrors.validField(
                            downPropertyLabel.ASSET_MOBILE
                          )
                        )
                      );
                    }
                  }
                }
              ]}
              label={downPropertyLabel.ASSET_MOBILE}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <PhoneNumberInput />
            </Form.Item>
          </Col> */}
          {/* <Col className="gutter-row" span={colSpan}> */}
          {/* <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.ASSET_EMAIL}
              label={downPropertyLabel.ASSET_EMAIL}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.ASSET_EMAIL)
                },
                {
                  min: 5,
                  message: `${downPropertyLabel.ASSET_EMAIL} Should be more than 4 Characters`
                },
                {
                  max: 320,
                  message: `${downPropertyLabel.ASSET_EMAIL} Should not be more than 320 Characters`
                },
                {
                  pattern: RegEx.email,
                  message: CommonErrors.validField(
                    downPropertyLabel.ASSET_EMAIL
                  )
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <Input placeholder={`Enter ${downPropertyLabel.ASSET_EMAIL}`} />
            </Form.Item>
          </Col> */}
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.VEHICLE_TYPE}
              // rules={[
              //   {
              //     required: true,
              //     message: CommonErrors.mandatory(
              //       downPropertyLabel.VEHICLE_TYPE
              //     )
              //   }
              // ]}
              label={downPropertyLabel.VEHICLE_TYPE}
              labelCol={{span: 24}}
              validateFirst={true}
              hasFeedback
            >
              <SelectWithOtherOption
                showSearch
                filterOption={filterSelectOptions}
                className="input"
                placeholder={`Choose ${downPropertyLabel.VEHICLE_TYPE}`}
                allowClear
                options={vehicleType}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={6}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.FUEL_USED}
              label={downPropertyLabel.FUEL_USED}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.FUEL_USED)
                }
              ]}
              labelCol={{span: 24}}
              validateFirst={true}
              hasFeedback
            >
              <Select
                showSearch
                filterOption={filterSelectOptions}
                className="select"
                placeholder={`Choose ${downPropertyLabel.FUEL_USED}`}
                options={vehicleFuelUsed?.filter(
                  (item) => item?.dbName === EfdbName.ghg_global
                )}
                onChange={(_, option) => {
                  setFuelState(option);
                }}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.FUEL_QUANTITY}
              label={downPropertyLabel.FUEL_QUANTITY}
              labelCol={{span: 24}}
              initialValue={undefined}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(
                    downPropertyLabel.FUEL_QUANTITY
                  )
                },
                {
                  pattern: RegEx.noZeroNoNegative,
                  message: 'Please enter non decimal value more than 0'
                }
              ]}
              validateFirst={true}
              hasFeedback
            >
              <NumberInput
                className="input"
                placeholder={`Enter ${downPropertyLabel.FUEL_QUANTITY}`}
                addonAfter={changeUnit(fuelState?.state)}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item
              name={downPropertyKey.RENTED_FROM}
              label={downPropertyLabel.RENTED_FROM}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(downPropertyLabel.RENTED_FROM)
                }
              ]}
              validateFirst={true}
              hasFeedback
              labelCol={{span: 24}}
            >
              <MomentDatePicker
                disabledDate={(current: any) => {
                  return moment() <= current || moment('1900/04') > current;
                }}
                inputReadOnly
                format="DD-MM-YYYY"
                style={{width: '100%'}}
                showNow={false}
                onChange={() => {
                  if (getFieldValue(downPropertyKey.RENTED_TO)) {
                    setFields([
                      {
                        name: downPropertyKey.RENTED_TO,
                        errors: [CommonErrors.selectAgain],
                        value: undefined
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {/* <Col className="gutter-row" span={colSpan}> */}
          <Col className="gutter-row">
            <Form.Item dependencies={[downPropertyKey.RENTED_FROM]}>
              {({getFieldValue}) => (
                <Form.Item
                  name={downPropertyKey.RENTED_TO}
                  label={downPropertyLabel.RENTED_TO}
                  shouldUpdate={true}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(
                        downPropertyLabel.RENTED_TO
                      )
                    }
                  ]}
                  validateFirst={true}
                  hasFeedback
                  labelCol={{span: 24}}
                >
                  <MomentDatePicker
                    disabledDate={(current: any) => {
                      return (
                        getFieldValue(downPropertyKey.RENTED_FROM) > current
                      );
                    }}
                    inputReadOnly
                    format="DD-MM-YYYY"
                    style={{width: '100%'}}
                    showNow={false}
                    disabled={!getFieldValue(downPropertyKey.RENTED_FROM)}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
};

export default DownPropertyForm;
